const defaultInterval = { min: 6, max: 23 };
export const getTime = ({ min, max } = defaultInterval, ratioMinutesTime) => {
    const result = [];
    // Recorriendo horas y formando hh:mm
    for (let hour = min; hour <= max; hour++) {
        for (let minute = 0; minute < 60; minute += ratioMinutesTime) {
            result.push([hour, minute]);
        } 
    }
    if (max !== 23 && ratioMinutesTime < 30) 
        // Insertando hora máxima en punto en caso de no ser 23
        result.push([max, 0]);
    return result;
}
export const getText = ([hour, minute]) => {
    return `${hour.toString().length === 1 
        ? 0 : ""}${hour}:${minute.toString().length === 1 
            ? 0 : ""}${minute}`;
}
export const getTextTimeByMinutes = (timeMinutes) => {
    return getText(getTimeParts(timeMinutes));
}
export const getTextByRangeMinutes = ({ start, end }, separator = "-") => {
    return `${getTextTimeByMinutes(start)} ${separator} ${getTextTimeByMinutes(end)}`;
}
export const getTimestamp = ([hour, minute]) => {
    return hour*60 + minute;
}
export const getHourByMinutes = minutes => {
    return Math.floor(minutes/60);
}
export const getTimeParts = timestamp => {
    if (timestamp === -1)
        return [-1, -1];
    if (timestamp === 0)
        return [0, 0];
    const hour = parseInt(timestamp / 60);
    const minute = (timestamp % 60);
    return [hour, minute];
}
export const getMinutesOfToday = () => {
    const currentDate = new Date();
    return currentDate.getHours() * 60 + currentDate.getMinutes(); 
}